import { render, staticRenderFns } from "./need-verification-in-service.vue?vue&type=template&id=2ada40f6&scoped=true"
import script from "./need-verification-in-service.vue?vue&type=script&lang=js"
export * from "./need-verification-in-service.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ada40f6",
  null
  
)

export default component.exports